module.exports = __webpack_public_path__ + "static/img/bcg_k7.e9131cdb.png";